export const filter = (data: Array<any>, contains: string, district?: Array<String>, platform?: string): Array<any> => {
    let start: number = 0,
        end: number = 0,
        contain: boolean = false,
        comma = false

    if (contains === '' && district && district.length === 0 && platform === '') return data

    if (contains.indexOf(':') > -1) {
        const res = contains.match(/\d+:\d*$/g)
        if (res) {
            start = Number(res[0].split(':')[0])
            end = Number(res[0].split(':')[1])
            contain = true
        }
    } else if (contains.indexOf(',') > -1) {
        comma = true
    }

    const temp: any = []

    if (comma) {
        const split = contains.split(',')
        const existing: any = {}
        for (let i = 0; i < split.length; i++) {
            for (let j = 0; j < data.length; j++) {
                if (split[i] === data[j].title && !existing[data[j].title]) {
                    temp.push(data[j])
                    existing[data[j].title] = true
                } else if (split[i] === data[j].deviceId && !existing[data[j].deviceId]) {
                    temp.push(data[j])
                    existing[data[j].deviceId] = true
                }
            }
        }
    } else {
        data.forEach((row: any) => {
            if (contains) {
                if (contain) {
                    if (row.title) {
                        const sp = row.title.split('_')
                        const num = Number(sp[sp.length - 1])
                        if (num >= start && num <= end && row.title.indexOf(contains.replace(/\d+:\d*$/g, '')) > -1)
                            temp.push(row)
                    }
                } else {
                    if (
                        row.title.indexOf(contains) > -1 ||
                        (row.deviceId && row.deviceId.indexOf(contains) > -1) ||
                        (row.DEUI && row.DEUI.indexOf(contains) > -1)
                    )
                        temp.push(row)
                }
            } else {
                if (platform && district && district.length > 0) {
                    if (
                        row.location &&
                        row.location.district &&
                        platform === row.platform &&
                        district.includes(row.location.district)
                    )
                        temp.push(row)
                } else if (platform && platform === row.platform) temp.push(row)
                else if (district && row.location && row.location.district) {
                    if (district.includes(row.location.district)) temp.push(row)
                }
            }
        })
    }

    return temp.sort((a: any, b: any) => {
        if (a.title > b.title) return 1
        else if ((a.title, b.title)) return -1
        return 0
    })
}
